import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
import account from './modules/account';
import cardMake from './modules/cardMake';
import card from './modules/card';
import subjects from './modules/subjects';
import answerPanel from './modules/answerPanel';

export default new Vuex.Store({
  modules: {
    account,
    cardMake,
    card,
    subjects,
    answerPanel,
  },
  // state: {
  // },
  // mutations: {
  // },
  // actions: {
  // },
  // modules: {
  // }
});
